export default "__VITE_ASSET__Boe873Jb__"